import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Route} from 'react-router-dom';
import PasswordResetForm from './PasswordResetForm';
import PasswordResetResult from './PasswordResetResult';
import {PageContainer, PageDescription, PageTitle} from '../../Common/PageComponents';

class PasswordReset extends Component {
  componentDidMount() {}

  render() {
    return (
      <PageContainer>
        <PageTitle title={'비밀번호 찾기'} />
        <PageDescription>
          사용하시는 비밀번호를 잊으셨나요? <br />
          아이디와 대표자 성명, 사업자등록번호로 본인 확인이 되시면 메일로 임시 비밀번호를 보내드립니다.
        </PageDescription>
        <Route exact path="/member-service/password-reset" component={PasswordResetForm} />
        <Route exact path="/member-service/password-reset/result" component={PasswordResetResult} />
      </PageContainer>
    );
  }
}

export default connect()(PasswordReset);
